import moment from "moment";
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { getData, postRawData, patchFormData } from "../../api";
import Loader from "../../component/Loader";
import { variants } from "../../constant/Variants";

function ImportExportRequest() {
  const navigate = useNavigate();
  const authState = useSelector((store) => store.auth);
  const [exportRequests, setExportRequests] = useState([]);
  const [requestsLoading, setRequestsLoading] = useState(false);
  const [selectedType, setSelectedType] = useState('user');

  const fetchExportRequests = async () => {
    setRequestsLoading(true);
    try {
      const response = await getData(`admin/getPendingExportRequests?type=${selectedType}`);
      if (response?.code === 1) {
        setExportRequests(response?.data?.list || []);
      } else {
        toast.error(response?.message || 'Failed to fetch export requests');
      }
    } catch (error) {
      console.error('Error fetching export requests:', error);
      toast.error('Failed to fetch export requests');
    } finally {
      setRequestsLoading(false);
    }
  };

  const handleApproveRequest = async (requestId) => {
    try {
      // Update the request status to approved (1)
      const response = await patchFormData('admin/updateExportRequestStatus', {
        request_id: requestId,
        status: 1
      });
      
      if (response?.code === 1) {
        toast.success('Export request approved successfully');
        fetchExportRequests(); // Refresh the list
      } else {
        toast.error(response?.message || 'Failed to approve request');
      }
    } catch (error) {
      console.error('Error approving request:', error);
      toast.error('Failed to approve request');
    }
  };

  const handleDisapproveRequest = async (requestId) => {
    try {
      // Update the request status to disapproved (2)
      const response = await patchFormData('admin/updateExportRequestStatus', {
        request_id: requestId,
        status: 2
      });
      
      if (response?.code === 1) {
        toast.success('Export request disapproved');
        fetchExportRequests(); // Refresh the list
      } else {
        toast.error(response?.message || 'Failed to disapprove request');
      }
    } catch (error) {
      console.error('Error disapproving request:', error);
      toast.error('Failed to disapprove request');
    }
  };

  useEffect(() => {
    fetchExportRequests();
  }, [selectedType]);

  return (
    <article className="col-lg-9 articleClass">
      <div className="article-body store-bd-gy">
        <div className="row align-items-center col-rever">
          <div className="col-sm-12 col-md-6 col-lg-6 mb-3">
            <div className="link-active shadow">
              <p>
                <img src="assets/images/event-calender-selected.png" alt="" />{" "}
                Export Requests {exportRequests.length}
              </p>
            </div>
          </div>
          <div className="col-sm-12 col-md-6 col-lg-6 mb-3">
            <div className="d-flex align-items-center lg-justify-content-end">
              <button
                className="btn btn-accept btn-view px-3 fs-normal ms-0"
                onClick={fetchExportRequests}
                disabled={requestsLoading}
              >
                <img
                  src="assets/images/refresh.png"
                  alt=""
                  className="download-icon"
                />
                {requestsLoading ? 'Refreshing...' : 'Refresh'}
              </button>
              <select
                className="form-control form-select ms-2"
                style={{width: 'auto'}}
                value={selectedType}
                onChange={(e) => setSelectedType(e.target.value)}
              >
                <option value="user">User Requests</option>
                <option value="student">Student Requests</option>
              </select>
            </div>
          </div>
        </div>
        <div className="row mt-1">
          <div className="col-sm-9 col-md-9 col-lg-10">
            <ul
              className="nav nav-pills group-nav mb-3"
              id="pills-tab"
              role="tablist"
            >
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link"
                  id="pills-users-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-users"
                  type="button"
                  role="tab"
                  aria-controls="pills-users"
                  aria-selected="false"
                  onClick={() => {
                    navigate("/import-export-data/user");
                  }}
                >
                  Users
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link"
                  id="pills-students-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-students"
                  type="button"
                  role="tab"
                  aria-controls="pills-students"
                  aria-selected="false"
                  onClick={() => {
                    navigate("/import-export-data/student");
                  }}
                >
                  Students
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link active"
                  id="pills-requests-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-requests"
                  type="button"
                  role="tab"
                  aria-controls="pills-requests"
                  aria-selected="true"
                >
                  Export Requests
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link"
                  id="pills-logs-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-logs"
                  type="button"
                  role="tab"
                  aria-controls="pills-logs"
                  aria-selected="false"
                  onClick={() => {
                    navigate("/import-export-data/logs");
                  }}
                >
                  Logs
                </button>
              </li>
            </ul>
          </div>
          <div className="col-sm-12">
            <div className="table-responsive text-center">
              <table className="table storetable">
                <thead className="text-center">
                  <tr>
                    <th scope="col">ID</th>
                    <th scope="col">Company Name</th>
                    <th scope="col">Status</th>
                    <th scope="col">Requested Date</th>
                    <th scope="col">Actions</th>
                  </tr>
                  <tr className="border-0 bg-none invisible">
                    <td className="border-0 bg-none"></td>
                  </tr>
                </thead>
                <tbody>
                  {requestsLoading ? (
                    <td colSpan={5}>
                      <Loader />
                    </td>
                  ) : (
                    <>
                      {exportRequests?.length > 0 ? (
                        exportRequests?.map((item, i) => {
                          return (
                            <tr variants={variants.card} key={i}>
                              <td>{item?.id || "NA"}</td>
                              <td>
                                {item?.company?.company_name ? item?.company?.company_name : "NA"}
                              </td>
                              <td>
                                <span className={`badge ${
                                  item?.status === 0 ? 'bg-warning' : 
                                  item?.status === 1 ? 'bg-success' : 
                                  'bg-danger'
                                }`}>
                                  {item?.status === 0 ? 'Pending' : 
                                   item?.status === 1 ? 'Approved' : 
                                   'Disapproved'}
                                </span>
                              </td>
                              <td>
                                {item?.createdAt ? moment(item?.createdAt).format("DD MMM YYYY") : "NA"}
                              </td>
                              <td>
                                <div className="d-flex justify-content-center action">
                                  {item?.status === 0 && (
                                    <>
                                      <button
                                        className="btn btn-sm btn-success me-2"
                                        onClick={() => handleApproveRequest(item.id)}
                                        title="Approve Request"
                                      >
                                        Approve
                                      </button>
                                      <button
                                        className="btn btn-sm btn-danger"
                                        onClick={() => handleDisapproveRequest(item.id)}
                                        title="Disapprove Request"
                                      >
                                        Disapprove
                                      </button>
                                    </>
                                  )}
                                  {item?.status === 1 && (
                                    <span className="text-success">
                                      <i className="fas fa-check-circle"></i> Approved
                                    </span>
                                  )}
                                  {item?.status === 2 && (
                                    <span className="text-danger">
                                      <i className="fas fa-times-circle"></i> Disapproved
                                    </span>
                                  )}
                                </div>
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan={5}>No export requests found.</td>
                        </tr>
                      )}
                    </>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </article>
  );
}

export default ImportExportRequest;
